export enum SideBarContent {
  ParticipantList = 'ParticipantList',
  SigningsMonthly = 'SigningsMonthly',
}
